<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Are you setting up a new or existing payroll?</h1>
    <p>Tell us whether this is a brand-new PAYE scheme or an existing payroll that has already been used to pay employees during the current tax year.</p>
    <p>If you're moving an existing payroll to us, we'll need your payroll brought-forward figures (year-to-date information) to make sure employee pay, tax and National Insurance records continue correctly.</p>
    
    <div class="radio-options">
      <label>
        <input type="radio" v-model="formData.payrollType" value="newscheme" />
        New Payroll Scheme
      </label>
      <label>
        <input type="radio" v-model="formData.payrollType" value="existingscheme" />
        Existing Payroll Scheme  
      </label>
    </div>
    </div>
    <div class="cell small-2">

    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.payrollType) {
    error.value.push('Please select whether this is a new or existing payroll scheme.');
  }

  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>